import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { untilDestroyed } from '$core/operators/until-destroyed.operator';
import { debounceTime } from 'rxjs/operators';
import { BLANK_STATUS_FILTERS } from '../../blanks.metadata';
import { Blank } from '../../models/blank';

@Component({
  selector: 'app-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FiltersComponent implements OnInit, OnDestroy {
  public readonly BLANK_STATUS_FILTERS = BLANK_STATUS_FILTERS;
  @Output() public removeChange: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  @Output() public searchChange: EventEmitter<string | null> = new EventEmitter<
    string | null
  >();
  @Output() public statusChange: EventEmitter<string | null> = new EventEmitter<
    string | null
  >();
  @Input() public selected: Blank[];

  public get queryParamMap() {
    return this._route.snapshot.queryParamMap;
  }

  public readonly faTrashAlt = faTrashAlt;
  public searchControl: FormControl = this._fb.control(
    this.queryParamMap.get('search')
  );
  constructor(
    private readonly _fb: FormBuilder,
    private readonly _route: ActivatedRoute
  ) {}

  public ngOnDestroy(): void {}

  public ngOnInit() {
    this.listenToSearch();
  }

  public changeStatus(status: string | null): void {
    if (status === this.queryParamMap.get('status')) {
      status = null;
    }
    this.statusChange.next(status);
  }

  public remove(): void {
    this.removeChange.next(true);
  }

  private listenToSearch(): void {
    this.searchControl.valueChanges
      .pipe(debounceTime(350), untilDestroyed(this))
      .subscribe((res) => {
        this.searchChange.next(res || null);
      });
  }
}
